// extracted by mini-css-extract-plugin
module.exports = {"currency":"CurrencySwitcher_currency__1fKn_"};